import update from 'immutability-helper';
import _ from 'lodash';
import { format, startOfMonth, endOfMonth, parseISO } from 'date-fns';
import I18n from '../../config/i18n';
import qwPartners from '../common/clients/qwPartners';
import { handleAppError } from './app';
import { showAppBusy } from './app';

const initialState = {
  calendarDays: [],
  activeDate: format(new Date(), 'yyyy-MM-dd'),
  holiday: false,
};

const RECEIVE_CALENDAR_DAYS = 'calendar/RECEIVE_CALENDAR_DAYS';
const UPDATE_ACTIVE_DATE = 'calendar/UPDATE_ACTIVE_DATE';
const TOGGLE_ACTIVE_DATE_AS_HOLIDAY = 'calendar/TOGGLE_ACTIVE_DATE_AS_HOLIDAY';

export function receiveCalendarDays(calendarDays) {
  return { type: RECEIVE_CALENDAR_DAYS, payload: calendarDays };
}

export function updateActiveDate(date) {
  return { type: UPDATE_ACTIVE_DATE, payload: date };
}

export function toggleActiveDateHolidayStatus(isHoliday) {
  return { type: TOGGLE_ACTIVE_DATE_AS_HOLIDAY, payload: isHoliday };
}

function frameDateRangeQueryString(date) {
  let startDate = format(startOfMonth(parseISO(date)), 'yyyy-MM-dd');
  let endDate = format(endOfMonth(parseISO(date)), 'yyyy-MM-dd');

  return `startDate=${startDate}&endDate=${endDate}`;
}

function doesDateFallsInExistingCalendarDays(date, calendarDays) {
  return calendarDays.find((day) => day.date === date);
}

export function fetchCalendarDays() {
  return (dispatch, getState) => {
    let { activeDate } = getState().calendar;

    let query = frameDateRangeQueryString(activeDate);
    dispatch(showAppBusy(true));

    return qwPartners
      .get(`/v1/partner/calendar?${query}`)
      .then((res) => res.data)
      .then((calendarDays) => {
        dispatch(receiveCalendarDays(calendarDays));
        dispatch(showAppBusy(false));
      })
      .catch((error) => {
        dispatch(showAppBusy(false));
        dispatch(handleAppError(error, I18n.t('unableToLoadCalendar')));
      });
  };
}

export function createCalendarEvent(data) {
  return (dispatch) => {
    dispatch(showAppBusy(true));

    return qwPartners
      .post('/v1/partner/calendar', data)
      .then(() => {
        dispatch(fetchCalendarDays());
      })
      .catch((error) => {
        dispatch(showAppBusy(false));
        dispatch(handleAppError(error, I18n.t('unableToSaveCalendarEvent')));
      });
  };
}

export function updateCalendarEvent(data) {
  return (dispatch, getState) => {
    let { partner } = getState().account.user;
    dispatch(showAppBusy(true));

    return qwPartners
      .put(`/v1/partner/${partner.org}/calendar`, data)
      .then(() => {
        dispatch(fetchCalendarDays());
      })
      .catch((error) => {
        dispatch(showAppBusy(false));
        dispatch(handleAppError(error, I18n.t('unableToSaveCalendarEvent')));
      });
  };
}

export function saveCalendarEvent() {
  return (dispatch, getState) => {
    let { activeDate: date, holiday, calendarDays } = getState().calendar;

    dispatch(showAppBusy(true));

    let existingCalendarEvent = _.cloneDeep(
      doesDateFallsInExistingCalendarDays(date, calendarDays),
    );
    if (existingCalendarEvent) {
      existingCalendarEvent.holiday = holiday;
      dispatch(updateCalendarEvent(existingCalendarEvent));
    } else {
      let data = {
        date,
        holiday,
      };
      dispatch(createCalendarEvent(data));
    }
  };
}

export function removeCalendarEvent() {
  return (dispatch, getState) => {
    let { activeDate: date, calendarDays } = getState().calendar;

    let existingCalendarEvent = _.cloneDeep(
      doesDateFallsInExistingCalendarDays(date, calendarDays),
    );
    if (existingCalendarEvent) {
      existingCalendarEvent.holiday = false;
      dispatch(updateCalendarEvent(existingCalendarEvent));
    } else {
      let data = {
        date,
        holiday: false,
      };

      dispatch(createCalendarEvent(data));
    }
  };
}

export default function reducer(state = initialState, action) {
  let { type, payload } = action;
  switch (type) {
    case RECEIVE_CALENDAR_DAYS:
      return update(state, { calendarDays: { $set: payload } });

    case UPDATE_ACTIVE_DATE:
      return update(state, { activeDate: { $set: payload } });

    case TOGGLE_ACTIVE_DATE_AS_HOLIDAY:
      return update(state, { holiday: { $set: payload } });

    default:
      return state;
  }
}
